import { render, staticRenderFns } from "./AfiliacionView.vue?vue&type=template&id=10e01a40&scoped=true&"
import script from "./AfiliacionView.vue?vue&type=script&lang=js&"
export * from "./AfiliacionView.vue?vue&type=script&lang=js&"
import style0 from "./AfiliacionView.vue?vue&type=style&index=0&id=10e01a40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e01a40",
  null
  
)

export default component.exports